"use client";

import Link from "next/link";
import { trackCategoryClick } from "@/lib/gtag";

export default function CategoryLink({
  slug,
  label,
}: {
  slug: string;
  label: string;
}) {
  return (
    <Link
      href={`/category/${slug}`}
      className="rounded-full border border-amber-200 bg-white px-4 py-2 text-sm font-medium text-amber-800 shadow-sm transition hover:bg-amber-100 hover:shadow"
      onClick={() => trackCategoryClick(label)}
    >
      {label}
    </Link>
  );
}
